import React from 'react';
import PropTypes from 'prop-types';

export function AdminListModal({ show, onClose, handleItemClick, listData, title }) {
    const handleOverlayClick = (e) => {
        if (e.target.className === 'admin-modal-overlay') {
            onClose();
        }
    };
    const handleItemSelect = (item) => {
        if (item?.id) {
            handleItemClick(item);
            onClose();
        }
    };

    if (!show) {
        return null;
    }
    return (
        <div className="admin-modal-overlay admin-user-list" onClick={handleOverlayClick}>
            <div className="admin-modal">
                <div className="admin-modal-scroll">
                    <button className="admin-modal-close" onClick={onClose}>
                        <span className="material-symbols-rounded">close</span>
                    </button>
                    <h2 className="admin-modal-heading">
                        {title}
                    </h2>
                    <div className="pt admin-users-modal-table">
                        <table className="admin-table">
                            <tbody>
                                <tr>
                                    <th className="admin-table-action-cell">First Name</th>
                                    <th className="admin-table-action-cell">Last Name</th>
                                    <th className="admin-table-action-cell">Primary Company</th>
                                    <th className="admin-table-action-cell">Date Added</th>
                                    <th className="admin-table-action-cell">Phone Number</th>
                                    <th className="admin-table-action-cell">&nbsp;</th>
                                    <th className="admin-table-action-cell">&nbsp;</th>
                                </tr>
                                {listData && listData.length > 0 ? (
                                    listData.filter(x => !x.isAdminUser).map(item =>
                                        <tr key={item.id} onClick={() => handleItemSelect(item)} >
                                            <td className="admin-table-name-cell">{item.firstName}</td>
                                            <td className="admin-table-name-cell">{item.lastName}</td>
                                            <td className="admin-table-name-cell">{item.primaryCompanyName}</td>
                                            <td className="admin-table-name-cell">{item.createdDate}</td>
                                            <td className="admin-table-name-cell">{item.mobile}</td>
                                        </tr>
                                    )) : (
                                    <tr>
                                        <td className="admin-table-name-cell" colSpan="6">No active Admin Users</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div> 
                </div>
            </div>
        </div>
    ); 
}

AdminListModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    handleItemClick: PropTypes.func.isRequired,
    listData: PropTypes.array,
    title: PropTypes.string
};